import React, { useState, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { PencilSquare, XSquare } from 'react-bootstrap-icons';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { Badge, Form } from 'react-bootstrap';
import Input from './common/Input';
import MyModal from './common/MyModal';


const Menu = (props) => {
    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);

    const { register, handleSubmit, errors, setValue } = useForm();

    const [name, setName] = useState('');
    const [displayOrder, setDisplayOrder] = useState(0);
    const [mode, setMode] = useState('create');
    const [disabled, setDisabled] = useState(true);
    const [editCat, setEditCat] = useState({});
    const [categoryTitle, setCategoryTitle] = useState('Add Menu');
    const [showModal, setShowModal] = useState(false);
    const [modalBody, setModalBody] = useState('');


    const fetchClient = () => {

        coreContext.fetchSelf(authContext.itemId);

    }

    useEffect(fetchClient, []);


    const renderCreatUpdateButtons = () => {

        if (mode === 'create') {
            return <Input value='Add' elementType='button' variant='primary' />
        } else if (mode === 'edit') {
            return <Input value='Edit' elementType='button' variant='dark' />
        }
    }

    const handleModalOpen = (cat) => {
        setShowModal(true);
        setMode('create');
        setName('');
        setEditCat(cat);
        setModalBody(cat.title + ' will be deleted permanently !');
    }
    const handleModalClose = () => {
        setShowModal(false);
    }

    const handleModalSubmit = (id) => {
        deleteRole(id);
        setShowModal(false);
    }

    const cancelUpdate = () => {
        setMode('create');
        setValue('name', '');
        setValue('displayorder', 0);
        setEditCat({});
        setCategoryTitle('Add Menu');
    }

    const renderCancelUpdateButton = () => {

        if (mode === 'create') {
            return '';
        } else if (mode === 'edit') {
            return <Input value='Cancel Edit' elementType='button' variant='warning' type='button' onClick={cancelUpdate} />
        }
    }

    const onSubmit = (data) => {
        if (mode === 'create') addRole(data.name, data.displayorder);
        else if (mode === 'edit') editRole(data.name, data.displayorder);
    }


    const editName = (cat) => {
        setValue('name', cat.title);
        setValue('displayorder', cat.displayOrder);
        setMode('edit');
        setDisabled(true);
        setEditCat(cat);
        coreContext.setMessage('');
        setCategoryTitle('Edit Menu');
    }

    const deleteRole = (id) => {
        coreContext.deleteMenu(id, coreContext.client.id);
        setEditCat({});
    }

    const addRole = (n, o) => {
        coreContext.addMenu(n, o, coreContext.client.id);
        setValue('name', '');
        setValue('displayorder', 0);
    }
    const editRole = (n, o) => {
        coreContext.editMenu(n, o, editCat.id, coreContext.client.id);
        setEditCat({});
        setMode('create');
        setValue('name', '');
        setValue('displayorder', 0);
    }

    const renderCategories = () => {
        if (coreContext.menus) {
            return coreContext.menus.map((cat, index) => (
                <tr key={++index}>
                    <td>{++index}</td>
                    <td>{cat.title}</td>
                    <td>{cat.displayOrder}</td>
                    <td><button onClick={() => editName(cat)} type="button" className="btn btn-success btn-sm" title="Edit Menu"><PencilSquare size="12" /></button>&nbsp;&nbsp;&nbsp;<button onClick={() => handleModalOpen(cat)} type="button" className="btn btn-danger btn-sm" title="Delete Menu"><XSquare size="12" /></button></td>
                </tr>
            ));
        }
        else {
            return (<tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>)
        }
    }

    return (
        <div className="row">
            <div className='col-md-4'>
                <div className="card" style={{ position: 'sticky', top: '50px' }}>
                    <div className="card-title mx-auto">
                        <h3>
                            <Badge variant="success">{categoryTitle}</Badge>
                        </h3>
                    </div>
                    <div className="card-body">
                        <Form autoComplete='off' onSubmit={handleSubmit(onSubmit)} noValidate>
                            <Input label='Name' name='name' value={name} minLength={3} maxLength={55} required={true} register={register}
                                errors={errors} elementType='text' placeholder='Enter Menu Title' />

                            <Input label='Display Order' name='displayorder' value={displayOrder} minLength={1} maxLength={55} required={true} register={register}
                                errors={errors} elementType='number' placeholder='Enter Display Order on Website' />

                            {renderCreatUpdateButtons()} &nbsp;&nbsp; {renderCancelUpdateButton()} &nbsp;&nbsp; {coreContext.renderLoader()}
                            <Input variant='danger' label={coreContext.message} elementType='label' />
                        </Form>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className="card">
                    <div className="card-title mx-auto">
                        <h3>
                            <Badge variant="success">Menus</Badge>
                        </h3>
                    </div>
                    <div className="card-body table-responsive">
                        <table className='table table-sm table-bordered'>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Display Order</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderCategories()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <MyModal handleModalClose={handleModalClose} handleModalSubmit={handleModalSubmit} showModal={showModal} modalBody={modalBody} cat={editCat} />
        </div>
    );
}


export { Menu };